// extracted by mini-css-extract-plugin
module.exports = {"AARS":"RiverAdvH5_AARS__0f0g_"};